<template>
  <SoPageWithHeader>
    <v-card>
      <v-toolbar class="px-4 py-2" density="compact" color="surface-dim">
        <v-toolbar-title>
          <h2 class="text-h4">Error Issuing Bill</h2>
        </v-toolbar-title>
      </v-toolbar>
      <SoRow>
        <SoCol>
          <v-window class="pa-8 pt-3">
            <SoAlert
              class="mt-8"
              type="error"
              title="Something went wrong. Please try again."
            >
              If the issue persists, there may be a problem with this account
              that's preventing the bill from being processed.
            </SoAlert>
            <div class="d-flex gap-2 mt-12">
              <SoButton
                type="secondary"
                title="Close"
                :to="{ name: 'CustomerFinancials' }"
                large
              />
              <SoButton
                type="primary"
                title="Try again"
                :to="{ name: 'CustomerIssueBill' }"
                large
              />
            </div>
          </v-window>
        </SoCol>
      </SoRow>
    </v-card>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoButton,
      SoCol,
      SoRow,
      SoAlert,
      SoPageWithHeader,
    },
  })
</script>
